//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
import MaskedInput from "./masked-input";
import DateInput from "./date-input";
import TextAreaInput from "./text-area-input";
export default defineComponent({
  name: "MultipleOptionsInput",
  components: {
    MaskedInput,
    DateInput,
    TextAreaInput
  },
  props: {
    colSize: {
      type: String,
      default: "6"
    },
    value: {
      type: Object,
      default: () => ({
        option: "",
        secondOption: "",
        text: ""
      })
    },
    options: {
      type: Array,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cols: {
      type: String,
      default: "4"
    },
    rows: {
      type: String,
      default: "3"
    }
  },
  data() {
    const defaultInputVal = this.options.some(option => option.multi) ? [] : {
      option: "",
      secondOption: "",
      secondOptionText: "",
      text: ""
    };
    return {
      answer: this.value || defaultInputVal
    };
  },
  watch: {
    "answer.secondOption"() {
      this.answer.secondOptionText = "";
      this.handleChange();
    },
    "value.option"() {
      this.answer.secondOptionText = "";
      this.answer.secondOption = "";
      this.handleChange();
    }
  },
  methods: {
    handleChange() {
      this.$emit("input", this.answer);
    },
    inputComponent(inputType = "text") {
      const inputComponentParser = {
        text: MaskedInput,
        date: DateInput,
        textarea: TextAreaInput
      };
      return inputComponentParser[inputType];
    },
    handleExplainChange(value) {
      if (typeof value == "object") {
        this.answer.secondOptionText = value.target.value;
      } else {
        this.answer.secondOptionText = value;
      }
      this.handleChange();
    },
    getOrder(position) {
      return position == "left" ? -1 : 2;
    }
  }
});